// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubModal-cls1__c01d02599a4931cbf2e6","cls2":"ImpactHubModal-cls2___8f307efae97d116e193 ImpactHubModal-cls1__c01d02599a4931cbf2e6"};